import * as mutationTypes from "./mutation-types";
export const mutations = {
  [mutationTypes.SET_SETTINGS]: (state, payload) => {
    console.log('4_mutations.js')
    state.settings=payload;  
  },
}

export default {
  mutations,
};